module.exports = __webpack_public_path__ + "static/img/document_active.977954b5.svg";